import { render, staticRenderFns } from "./PointPoolComponent.vue?vue&type=template&id=390422cc&scoped=true"
import script from "./PointPoolComponent.vue?vue&type=script&lang=js"
export * from "./PointPoolComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390422cc",
  null
  
)

export default component.exports